import type { LegacyMigrationListItem } from '@flux/shared';
import { formatCountLabel, formatEuros } from './money.js';

/**
 * Valeurs dérivées d'une migration legacy, partagées par la liste et le
 * panneau (`06` §5, §8.3). `null` = afficher « — ».
 */

/** `60,00 € → 44,53 €` : prix legacy ajusté puis nouveau prix. */
export function migrationPriceChange(
  item: Pick<LegacyMigrationListItem, 'adjustedLegacyPrice' | 'newPrice'>,
): string | null {
  const before = formatEuros(item.adjustedLegacyPrice);
  const after = formatEuros(item.newPrice);
  return before === null || after === null ? null : `${before} → ${after}`;
}

/** `4 produits`. */
export function migrationComposition(item: Pick<LegacyMigrationListItem, 'productCount'>): string {
  return formatCountLabel(item.productCount, 'produit', 'produits');
}

/** Palier de remise : `22 %`. */
export function migrationTier(item: Pick<LegacyMigrationListItem, 'bundle'>): string | null {
  return item.bundle === null ? null : `${String(item.bundle.percent)}\u00A0%`;
}

/** Nom court du bundle, sans le préfixe « Abonnement - » (`06` §5.5). */
export function shortBundleName(name: string): string {
  return name.replace(/^\s*Abonnement\s*-\s*/i, '').trim() || name;
}
